import { useEffect, useState } from "react"
import metaDataServices from "../MetaDataServices"
import CueProductUpsert from "./cueProduct_upsert";
import CustomFilter from "../Custom_Filter";
import DeleteDialogueBox from "components/Common/deleteDialogue";

export default function CueProduct(subEntity: any) {

    var payLoad = { pageNumber: 1, pageSize: 10 };
    let [cueOpen, SetcueOpen] = useState(false);
    let [cuelistCount, SetcuelistCount] = useState(0);
    let [deleteRow, SetDeleteRow] = useState<any>([]);
    let [cueUpsert, SetcuelUpsert] = useState<any>([]);
    let [deleteConfirm, SetDeleteConfirm] = useState(false);
    let [cueProductlist, SetcueProductlist] = useState<any>([]);
    let [CustomFilterOpen, SetCustomFilterOpen] = useState(false);

    const onChangecueUpsert = (e: any) => {
        console.log(e)
        cueOpen = false;
        SetcueOpen(cueOpen)
        apiCall();
    }

    const openCueEdit = (e: any) => {
        cueUpsert = e;
        SetcuelUpsert(e)

        cueOpen = true;
        SetcueOpen(cueOpen)
    }

    useEffect(() => {
        apiCall();
    }, [subEntity])

    const apiCall = () => {

        metaDataServices.cueProductlistSearch(payLoad).then((res: any) => {
            cueProductlist = res
            SetcueProductlist(cueProductlist);
            cuelistCount = res[0]?.totalRows ?? 0
            SetcuelistCount(cuelistCount)

        })
    }

    const onChangeCustomFilter = (e: any) => {
        CustomFilterOpen = false;
        SetCustomFilterOpen(CustomFilterOpen)
        apiCall();
    }

    const deleteConfirmation = (e: any) => {
        console.log(e)
        console.log(deleteRow)
        if (e == 1) {
            metaDataServices.cueProductDelete(deleteRow.cueId).then((res: any) => {
                apiCall();
            })
        }

        deleteConfirm = false;
        SetDeleteConfirm(deleteConfirm)
    }

    let [searchFor, SetSearch] = useState("");
    let [activitySelection, SetactivitySelection] = useState("");
    let [statusSelection, SetStatusSelection] = useState("");
    let [updatedSelection, SetupdatedSelection] = useState("");

    const clearFilter = () => {
        searchFor = '';
        SetSearch(searchFor)

        activitySelection = '';
        SetactivitySelection(activitySelection)

        statusSelection = '';
        SetStatusSelection(statusSelection)

        updatedSelection = '';
        SetupdatedSelection(updatedSelection)
    }

    return (<>

        <div className="ws-12 ps"> 

            <div className='ws-12 box mbl'>
                <div className='ws-12 pm'>

                    <div className='w-75'>
                        <div className='ws-6 box ps height40'>
                            <input type="text" className="ws-12 pull-right height30" value={searchFor} onChange={(e) => SetSearch(e.target.value)}
                                placeholder='Search by Master Cue, Cue Theme' style={{ border: 'none', outline: 'none' }} />
                        </div>

                        <select className='pm pbl height40 grey text-bold icon-btn info' value={statusSelection} onChange={(e: any) => SetStatusSelection(e.target.value)}>
                            <option value={'All'}> All</option>
                            <option value={'BECS Member'}> Cue Member</option>
                        </select>

                        <button className='pm pbl height40 width90 white text-bold icon-btn info' onClick={() => SetCustomFilterOpen(true)}>
                            Filter
                        </button>
                    </div>

                    {(searchFor.length > 0 || statusSelection.length > 0 || activitySelection.length > 0 || updatedSelection.length > 0) &&
                        <button type="button" className="text-bold icon-btn delete height40 mr pull-left width70" onClick={clearFilter}>Clear</button>}
                    <button type="button" className="text-bold icon-btn edit pull-right height40" onClick={() => openCueEdit({})}>New Cue Product</button>
                    <button type="button" className="text-bold icon-btn info pull-right height40" >Export</button>
                </div>
            </div>

            {(searchFor.length > 0 || statusSelection.length > 0 || activitySelection.length > 0 || updatedSelection.length > 0) && <div className='ws-12 pm'>

                <div className='ws-12 box landing pm text-center'>
                    {searchFor.length > 0 && <>
                        <span className='text-bold mr'>Search : </span>
                        <span className='mr'>{searchFor} </span>
                    </>}

                    {statusSelection.length > 0 && <>
                        <span className='text-bold mr'>Status :</span>
                        <span className='mr'>{statusSelection}</span>
                    </>}

                    {activitySelection.length > 0 && <>
                        <span className='text-bold mr'>Activity :</span>
                        <span className='mr'>{activitySelection}</span>
                    </>}
                    {updatedSelection.length > 0 && <>
                        <span className='text-bold mr'>Updated :</span>
                        <span className='mr'>{updatedSelection}</span>
                    </>}
                </div>

            </div>}

            <div className="ws-12 allowHscroll allowVscroll">

                <table className="newTable">
                    <thead>
                        <tr>
                            <th >Program Type</th>
                            <th style={{ width: "25%" }}>Cue SheetType</th>
                            <th >Production Id</th>
                            <th >Program Number</th>
                            <th >Cue Theme</th>
                            <th >Cue Status</th>
                            <th >Extended Status</th>
                            <th >Runtime</th>
                            <th style={{ width: "14%" }}>Operations</th>
                        </tr>
                    </thead>
                    <tbody>

                        {cueProductlist.map((row: any) => (
                            <tr>
                                <td>{row.proramType}</td>
                                <td>{row.programName}</td>
                                <td>{row.programNumber}</td>
                                <td>{row.programNumber}</td>
                                <td>{row.productionNumber}</td>
                                <td>{row.productionName}</td>
                                <td>{row.masterCue}</td>
                                <td>  {String(row.runtimeDurationMinute).padStart(2, '0')} : {String(row.runtimeDurationSecond).padStart(2, '0')} </td>
                                <td>

                                    <button className="icon-btn edit" title="Edit" type="button" onClick={() => openCueEdit(row)}>
                                        <i className="icon-pencil"> </i>
                                    </button>

                                    <button className="icon-btn delete" title="Delete" type="button" onClick={() => { SetDeleteConfirm(true); SetDeleteRow(row) }}>
                                        <i className="icon-trash"> </i>
                                    </button>

                                    <button className="icon-btn info" title="Report 801" type="button">
                                        <i className="icon-file"> </i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>

            </div>

            {
                (() => {
                    if (cueOpen) {
                        return <CueProductUpsert onChange={onChangecueUpsert} cueUpsert={cueUpsert} cueOpen={cueOpen} />
                    }
                    if (CustomFilterOpen) {
                        return <CustomFilter onChange={onChangeCustomFilter} CustomFilterOpen={CustomFilterOpen} type="CueListing" />
                    }

                    if (deleteConfirm) {
                        return <DeleteDialogueBox param={true} message={"you want to remove this product cue"} onChange={deleteConfirmation} />
                    }


                })()
            }
        </div>

    </>)

}